<template>
    <div>

        <div class="overlay" id="nav-overlay">
            <ul class="overlay-list">
                <li class="nav-item">
                    <router-link class="nav-link" @click.native="toggleMobileMenu" to="/">Home</router-link>
                </li>
                <li class="nav-item">
                    <router-link class="nav-link" @click.native="toggleMobileMenu" to="/about">About</router-link>
                </li>
                <li class="nav-item">
                    <router-link class="nav-link" @click.native="toggleMobileMenu" to="/portfolio">Portfolio</router-link>
                </li>
                <li class="nav-item">
                    <router-link class="nav-link" @click.native="toggleMobileMenu" to="/contacts">Contacts</router-link>
                </li>
            </ul>
        </div>

        <nav class="navbar navbar-expand-sm fixed-top navbar-light" :class="{'nav-compressed': (scrollPosition > 60 || this.$route.path != '/') }" id="navbarTop">
            <div class="container-fluid">
                <router-link class="navbar-brand" to="/"><img class="logo" src="../assets/img/gobig.png" alt="gobig"/></router-link>
                <div class="justify-content-end d-none d-md-block" id="navbarNav">
                    <ul class="navbar-nav">
                        <li class="nav-item">
                            <router-link class="nav-link" to="/">Home</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link class="nav-link" to="/about">About</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link class="nav-link" to="/portfolio">Portfolio</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link class="nav-link" to="/contacts">Contacts</router-link>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
        <div class="hamburger hamburger-3dx d-xs-block d-sm-block d-md-none" id="hamburger-toggle" v-on:click="toggleMobileMenu">
            <div class="hamburger-box">
                <div class="hamburger-inner"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NavMenu',
    data () {
        return {
            scrollPosition: null
        }
    },
    methods: {
        updateScroll () {
            this.scrollPosition = window.scrollY
        },
        toggleMobileMenu () {
            var overlay = document.getElementById('nav-overlay')
            var hamburger = document.getElementById('hamburger-toggle')
            overlay.classList.toggle('active')
            hamburger.classList.toggle('is-active')
        }
    },
    mounted () {
        window.addEventListener('scroll', this.updateScroll)
    }
}
</script>

<style lang="scss">

.navbar{
    background:$orange;
    .navbar-brand{
        .logo{
            width: 140px; transition: width 0.2s linear 0s;
        }
    }
    .navbar-nav{
        li.nav-item{
            a.nav-link{
                color:$white; font-size: 22px;
                &.router-link-exact-active{
                    color:#ffb26f!important;
                }
            }

        }
    }
}

.nav-compressed {
    box-shadow: 1px 2px 2px rgba(0,0,0,0.2); background:darken($orange, 5);
    .navbar-brand{
        .logo {
            width: 100px;
        }
    }
    .navbar-nav{
        li.nav-item{
            a.nav-link{
                font-size: 20px;
            }
        }
    }
}

.overlay {
    height: 100%; width: 100%; position: fixed; z-index: 1040; top: 0; overflow-x: hidden; background-color: $orange; background-color: rgba(0,0,0, 0.8); transition: 0.5s;
    right:100%;
    transition: all 0.5s ease;
    ul.overlay-list{
        width:100%; margin: 0; padding:0; position: absolute; top: 50%; left: 50%; -ms-transform: translate(-50%, -50%); transform: translate(-50%, -50%); text-align:center;
        li a{
            color:#FFF; text-transform: uppercase; font-size:2em; text-shadow: 1px 1px 5px rgba(0,0,0,0.3);
        }
    }
}

.overlay.active {
    right:0;
}

.hamburger{
    z-index: 1050;
    position: fixed;
    top:0;
    right: 0;
    margin: 15px 10px;
}

</style>
